exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".structure-tree{border:1px solid}.structure-user{border:none}.structure-tree .structure-child{padding:0}.structure-tree td{padding:1%}.structure-child table{margin:10px 10px 10px 0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-2e2ac5e3!./~/vue-loader/lib/selector.js?type=styles&index=0!./app/components/ia/StructurePrintList.vue
// module id = 239
// module chunks = 0